// 全局域名配置
const DOMAIN_CONFIG = {
  // OVERSEAS_DOMAIN: 'localhost.bluexad.ai', // 海外测试域名
  // DOMESTIC_DOMAIN: 'localhost.domob.cn',   // 国内测试域名
  OVERSEAS_DOMAIN: 'developer.bluexad.ai', // 海外测试域名
  DOMESTIC_DOMAIN: 'developer.domob.cn',   // 国内测试域名
};

module.exports = DOMAIN_CONFIG;